<script>
  // # # # # # # # # # # # # #
  //
  //  Contact page
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";

  // *** PROP
  export let endpoint = "";
  export let title = "";

  const post = loadData();

  // *** ON MOUNT
  async function loadData() {
    const res = await fetch(endpoint);
    const post = await res.json();
    return post;
  }

  // *** ON MOUNT
  onMount(async () => {
    window.scrollTo(0, 0);
  });
</script>

<style lang="scss">
  @import "../_variables.scss";

  .contact {
    color: $black;
    display: inline-block;
    margin-top: 120px;
    margin-bottom: 80px;
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    font-family: $serif-stack;

    @include screen-size("small") {
      width: calc(100vw - 40px);
      margin-right: 20px;
      margin-left: 20px;
    }

    p {
      margin-top: 0;
      margin-bottom: 1em;
    }

    &__body {
      margin-left: auto;
      margin-right: auto;
      width: 50%;
      display: flex;
      flex-flow: column;
      justify-content: center;
      font-size: $font-size-large;
      line-height: $normal-line-height;
      text-align: center;

      @include screen-size("small") {
        width: unset;
        font-size: $mobile-font-size-medium;
      }
    }

    &__section {
      width: 100%;
      margin-bottom: 30px;

      &--left {
        text-align: right;
        padding-right: 10px;
      }

      &--right {
        text-align: left;
        padding-left: 10px;
      }
    }
  }

  a {
    color: currentColor;
    border-bottom: none;

    @include normal-hover-state;
  }

  .mailing-list {
    font-size: $font-size-large;
    line-height: 1.3em;
    font-family: $serif-stack;

    @include screen-size("small") {
      font-size: $mobile-font-size-medium;
    }

    &__input {
      border: none;
      border-bottom: 1px solid $black;
      height: 1.3em;
      font-family: $serif-stack;
      font-size: $font-size-large;
      line-height: 1.3em;
      padding: 5px;
      outline: none;
      min-width: 24ch;
      margin-right: 5px;
      // background: yellow;
      text-align: left;

      @include screen-size("small") {
        text-align: center;
        min-width: unset;
        font-size: $mobile-font-size-medium;
      }
    }
    &__submit {
      font-family: $serif-stack;
      font-size: $font-size-large;
      height: 1.3em;
      border: none;
      background: transparent;
      padding: 5px;
      display: inline-block;
      margin-top: 5px;
      outline: none;
      padding-bottom: 15px;
      cursor: pointer;

      @include normal-hover-state;

      @include screen-size("small") {
        font-size: $mobile-font-size-medium;
      }
    }
  }
</style>

<svelte:head>
  <title>{title} | COMPLETE WORKS</title>
</svelte:head>

{#await post then post}

  <div class="contact" in:fade>

    <div class="contact__body">
      {@html post.header.column_one}

      <div class="contact__section">
        <div class="mailing-list">

          <!-- Begin Mailchimp Signup Form -->
          <div id="mc_embed_signup">
            <form
              action="https://completeworks.us19.list-manage.com/subscribe/post?u=fe42c786ef25d500906243336&amp;id=74a325677b"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              class="validate"
              target="_blank"
              novalidate>
              <div id="mc_embed_signup_scroll">

                <div class="mc-field-group">
                  <input
                    placeholder="Mailing list"
                    type="email"
                    value=""
                    name="EMAIL"
                    class="mailing-list__input"
                    id="mce-EMAIL" />
                  <input
                    type="submit"
                    value="Sign up"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    class="mailing-list__submit" />
                </div>

                <div id="mce-responses" class="clear">
                  <div
                    class="response"
                    id="mce-error-response"
                    style="display:none" />
                  <div
                    class="response"
                    id="mce-success-response"
                    style="display:none" />
                </div>

                <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div
                  style="position: absolute; left: -5000px;"
                  aria-hidden="true">
                  <input
                    type="text"
                    name="b_fe42c786ef25d500906243336_74a325677b"
                    tabindex="-1"
                    value="" />
                </div>

                <div class="clear" />
              </div>
            </form>
          </div>

        </div>
      </div>

      {@html post.header.column_two}

    </div>

  </div>

{/await}
